import { useQuery } from 'react-query';
import request from '../../../helpers/request';
import { queryKeys } from './queryKeys';

const getAllowedEntity = async (typeId) => {
  return await request.get(
    `/Docs/types/bind/allowed_entity?typeId=${typeId}&bindEntityTypeId=2`,
    null,
    'При загрузке типов связанных объектов произошла ошибка'
  );
};

const useAllowedEntityQuery = (typeId, options) =>
  useQuery(
    queryKeys.allowedEntity(typeId),
    () => getAllowedEntity(typeId),
    options
  );

export default useAllowedEntityQuery;
